import { createSlice } from '@reduxjs/toolkit'

export const newAnimeModalSlice = createSlice({
    name: 'isNewAnimeModalOpen',
    initialState: {
        value: false
    },
    reducers: {
        openNewAnimeModal: state => {
            state.value = true;
        },
        closeNewAnimeModal: state => {
            state.value = false;
        }
    }
});

export const {
    openNewAnimeModal,
    closeNewAnimeModal
} = newAnimeModalSlice.actions;